import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  changePwdService,
  changeTemPwdService,
  fetchUserDetails,
  updateUser,
} from "../../services/UserServices";
import config from "../../config";
import avatar from "../../images/avatar/profile_avatar.png";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import formatError from "../../services/FormatError";
import { is, tr } from "date-fns/locale";
const MyProfile = () => {
  const { t } = useTranslation();
  const user = JSON.parse(sessionStorage.getItem("userDetails"))?.result;
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(false);
  // edit form data submit
  const [isInputDisabled, setIsInputDisabled] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchUserDetails(user?.user?.id).then((res) => {
      setUserDetails(res?.data?.result);
      console.log(res?.data?.result);
      setLoading(false);
    });
  }, [isInputDisabled]);

  const updateUserDetails = (key, value) => {
    setUserDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  // Save edit changes function ---
  const [loadingEdit, setLoadingEdit] = useState(false);
  const onSaveChanges = () => {
    updateUser(user?.user?.id, userDetails)
      .then((res) => {
        if (res.status === 200) {
          swal("Success", "User updated successfully", "success");
        }
        setIsInputDisabled(true);
        setLoadingEdit(false);
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
        setIsInputDisabled(true);
        setLoadingEdit(false);
      });
  };
  // Change Password ---
  const [currentPassword, setCurrentPassword] = useState("");
  const [currentPasswordView, setCurrentPasswordView] = useState(false);
  const [cuttentPwdRequired, setCuttentPwdRequired] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [newPasswordView, setNewPasswordView] = useState(false);

  const [changePwdLoading, setChangePwdLoading] = useState(false);
  const onChangePwdSubmit = (e) => {
    e.preventDefault();
    setChangePwdLoading(true);
    if (newPassword !== "" && currentPassword !== "") {
      changePwdService(user?.user?.id, {
        newPwd: newPassword,
        oldPwd: currentPassword,
      })
        .then((res) => {
          if (res.status === 200) {
            swal("Success", "Password changed successfully", "success");
            sessionStorage.removeItem("userDetails");
            navigate("/login");
            window.location.reload();
          }
          setChangePwdLoading(false);
          setCurrentPassword("");
          setNewPassword("");
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
          setChangePwdLoading(false);
        });
    } else {
    }
  };
  return (
    <div>
      <div className="card p-4">
        <h4 className="card-title mb-0">My Profile</h4>
      </div>
      {/* Profile Header -------------- */}
      <div className="profile-header">
        <img
          className=" rounded-circle object-cover d-block"
          style={{ width: "100px", height: "100px" }}
          src={
            userDetails?.PhotoKey
              ? `${config.appUrl}file/view?key=${userDetails?.PhotoKey}&type=IMAGE`
              : avatar
          }
          alt="avatar"
        />

        <h1 className="profile-title">
          {userDetails?.firstname} {userDetails?.lastname}
        </h1>

        {userDetails?.email && (
          <div className=" mb-0">({userDetails?.email})</div>
        )}
      </div>

      <div className="row">
        <div className="mb-3 shadow-sm">
          <div
            style={{
              fontWeight: "bold",
              textTransform: "uppercase",
              marginTop: "30px",
              paddingTop: "15px",
              backgroundColor: "#310247",
            }}
          >
            <div className="d-flex justify-content-between">
              <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                {t("hinfosGeneral")}
              </h4>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-primary d-flex align-items-center gap-2 mx-2"
                  onClick={() => setIsInputDisabled(false)}
                >
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>Edit
                  Profile
                </button>
                {!isInputDisabled && (
                  <button
                    className="btn btn-danger d-flex align-items-center gap-2 mx-2"
                    onClick={() => setIsInputDisabled(true)}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>
            <hr />
          </div>

          <div className="card-body p-0">
            {/* General Information Section */}
            <div className="row">
              <div className="col-md-6">
                <div className={`form-group mb-1`}>
                  <label className="mb-1">
                    <strong>{t("nameInput")}</strong>
                  </label>
                  <input
                    type="text"
                    disabled={isInputDisabled}
                    placeholder={t("nameInput")}
                    className="form-control"
                    value={userDetails?.firstname}
                    onChange={(e) =>
                      updateUserDetails("firstname", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className={`form-group mb-1`}>
                  <label className="mb-1">
                    <strong>{t("nameInput")}</strong>
                  </label>
                  <input
                    type="text"
                    disabled={isInputDisabled}
                    placeholder={t("nameInput")}
                    className="form-control"
                    value={userDetails?.lastname}
                    onChange={(e) =>
                      updateUserDetails("lastname", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("emailInput")}</strong>{" "}
                  </label>
                  <input
                    type="email"
                    placeholder={t("emailInput")}
                    className="form-control"
                    required
                    disabled={true}
                    value={userDetails?.email}
                    onChange={(e) => updateUserDetails("email", e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("websiteInput")}</strong>
                  </label>
                  <input
                    type="text"
                    placeholder={t("websiteInput")}
                    className="form-control"
                    disabled={isInputDisabled}
                    value={userDetails?.website}
                    onChange={(e) =>
                      updateUserDetails("website", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className={`form-group mb-1`}>
                  <label className="mb-1">
                    <strong>{t("phoneInput")}</strong>
                  </label>
                  <input
                    type="tel"
                    placeholder={t("phoneInput")}
                    disabled={isInputDisabled}
                    className="form-control"
                    value={userDetails?.phone}
                    onChange={(e) => updateUserDetails("phone", e.target.value)}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("faxNumberInput")}</strong>
                  </label>
                  <input
                    type="tel"
                    disabled={isInputDisabled}
                    placeholder={t("faxNumberInput")}
                    className="form-control"
                    value={userDetails?.fax}
                    onChange={(e) => updateUserDetails("fax", e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Location Information Section */}
            <div
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginTop: "30px",
                paddingTop: "15px",
                backgroundColor: "#310247",
              }}
            >
              <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                {t("locationInformationSection")}
              </h4>
              <hr />
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("addressInput")}</strong>
                  </label>

                  <input
                    type="text"
                    placeholder={t("addressInput")}
                    className="form-control"
                    disabled={isInputDisabled}
                    value={userDetails?.address}
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("cityInput")}</strong>{" "}
                  </label>
                  <input
                    type="text"
                    placeholder={t("cityInput")}
                    className="form-control"
                    disabled={isInputDisabled}
                    value={userDetails?.city}
                    onChange={(e) => updateUserDetails("city", e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className={`form-group mb-1`}>
                  <label className="mb-1">
                    &ensp;
                    <strong>{t("regionInput")}</strong>
                  </label>
                  <input
                    type="text"
                    placeholder={t("regionInput")}
                    className="form-control"
                    value={userDetails?.region}
                    disabled={isInputDisabled}
                    onChange={(e) =>
                      updateUserDetails("region", e.target.value)
                    }
                  />

                  {/* <select
                            className="form-control"
                            style={{ border: "1px solid #EEEEEE" }}
                            value={userDetails?.region}
                            onChange={(e) =>
                              updateUserDetails("region", e.target.value)
                            }
                          >
                            <option value="">{t("globalSelect")}</option>
                            <option value="Alberta">{t("halberta")}</option>
                            <option value="British Columbia">
                              {t("hbritishcolumbia")}
                            </option>
                            <option value="Manitoba">{t("hmanitoba")}</option>
                            <option value="New Brunswick">
                              {t("hnewbrunswick")}
                            </option>
                            <option value="Newfoundland and Labrador">
                              {t("hnewfoundland")}
                            </option>
                            <option value="Northwest Territories">
                              {t("hnorthwestterritories")}
                            </option>
                            <option value="Nova Scotia">{t("hnovascotia")}</option>
                            <option value="Nunavut">{t("hnunavut")}</option>
                            <option value="Ontario">{t("hontario")}</option>
                            <option value="Prince Edward Island">{t("hpei")}</option>
                            <option value="Quebec">{t("hquebec")}</option>
                            <option value="Saskatchewan">{t("hsaskatchewan")}</option>
                            <option value="Yukon">{t("hyukon")}</option>
                          </select> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>{t("postalCodeInput")}</strong>
                  </label>
                  <input
                    type="text"
                    disabled={isInputDisabled}
                    placeholder={t("postalCodeInput")}
                    className="form-control"
                    value={userDetails?.postalCode}
                    onChange={(e) =>
                      updateUserDetails("postalCode", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className={`form-groupmb-1`}>
                  <label className="mb-1">
                    <strong>{t("countryInput")}</strong>
                  </label>
                  <input
                    type="text"
                    disabled={isInputDisabled}
                    placeholder={t("countryInput")}
                    className="form-control"
                    value={userDetails?.country}
                    onChange={(e) =>
                      updateUserDetails("country", e.target.value)
                    }
                  />
                  {/* <Select
                            isClearable
                            options={availableCountries}
                            placeholder={t("countryPlaceholder")}
                            styles={customStyles}
                            value={
                              userDetails?.country
                                ? availableCountries.find(
                                    (country) =>
                                      country.value === buyerDetails.country
                                  ) || null
                                : null
                            }
                            onChange={handleCountryChange}
                            isDisabled={!selectedRegion}
                          /> */}
                </div>
              </div>
              {!isInputDisabled && (
                <div className="d-flex justify-content-center my-4">
                  <button
                    onClick={onSaveChanges}
                    disabled={loadingEdit}
                    className="btn btn-primary"
                  >
                    Save changes{" "}
                    {loadingEdit && (
                      <div
                        class="spinner-border text-light spinner-border-sm "
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                </div>
              )}
            </div>

            {/* Change password section */}
            <div
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginTop: "30px",
                paddingTop: "15px",
                backgroundColor: "#310247",
              }}
            >
              <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                Change Password
              </h4>
              <hr />
            </div>

            <form onSubmit={(e) => onChangePwdSubmit(e)}>
              <div className="row">
                <div className="col-md-6">
                  <div className={`form-group mb-1`}>
                    <label className="mb-1">
                      <strong>Current Password</strong>{" "}
                    </label>
                    <div className="input-group">
                      <input
                        type={currentPasswordView ? "text" : "password"}
                        placeholder="Current Password"
                        className={`form-control ${
                          cuttentPwdRequired && "border-danger"
                        }`}
                        onFocus={() => setCuttentPwdRequired(false)}
                        required
                        disabled={changePwdLoading}
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                      <button
                        type="button"
                        className=" input-group-text"
                        onClick={() =>
                          setCurrentPasswordView(!currentPasswordView)
                        }
                      >
                        {currentPasswordView ? (
                          <i class="fa fa-eye" aria-hidden="true"></i>
                        ) : (
                          <i class="fa fa-eye-slash" aria-hidden="true"></i>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className={`form-group mb-1`}>
                    <label className="mb-1">
                      <strong>New Password</strong>{" "}
                    </label>
                    <div className="input-group">
                      <input
                        type={newPasswordView ? "text" : "password"}
                        placeholder="New Password"
                        className="form-control"
                        required
                        onClick={() =>
                          !currentPassword && setCuttentPwdRequired(true)
                        }
                        disabled={changePwdLoading}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <button
                        type="button"
                        className=" input-group-text"
                        onClick={() => setNewPasswordView(!newPasswordView)}
                      >
                        {newPasswordView ? (
                          <i class="fa fa-eye" aria-hidden="true"></i>
                        ) : (
                          <i class="fa fa-eye-slash" aria-hidden="true"></i>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center my-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={changePwdLoading}
                >
                  Change Password{" "}
                  {changePwdLoading && (
                    <div
                      class="spinner-border text-light spinner-border-sm "
                      role="status"
                    >
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
